import { EllipsisAccordion, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";
import { isVideoSeason, isVideoSpotLiveSeason } from "~/components/blocks/product/type-guard";
import { useMatchMedia } from "~/hooks/use-match-media";
import { useQueryString } from "~/hooks/use-query-string";
import type { G_GetVideoQuery } from "~/lib/graphql";

export type HighlightProps = {
  videoData: G_GetVideoQuery["video"];
};

/**
 * 見どころセクションを表示するコンポーネント
 * - 複数話 と 単話 と スポット配信 の場合のみ「見どころ」を表示させる
 * @param props {@link HighlightProps}
 */
export const Highlight = ({ videoData }: HighlightProps) => {
  const { isSpSize } = useMatchMedia();
  const { content } = useQueryString();

  if (content !== undefined) return null;

  if (isVideoSeason(videoData) || isVideoSpotLiveSeason(videoData)) {
    const { highlight } = videoData;

    if (highlight === undefined || highlight === null || highlight === "") return null;

    return (
      <Styled.SecRootHighlight>
        <Styled.Heading>見どころ</Styled.Heading>

        <EllipsisAccordion
          line={3}
          text={<Styled.DivHTMLWrapper dangerouslySetInnerHTML={{ __html: highlight }} />}
          label="highlight"
          fontSize={!isSpSize ? FONT_SIZE.M : FONT_SIZE.S}
          lineHeight={1.6}
        />
      </Styled.SecRootHighlight>
    );
  }

  return null;
};
